import { Injectable, PLATFORM_ID, DOCUMENT, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsService } from './settings.service';
import { Padding } from '../models/page-components/padding.model';
import { Margin } from '../models/page-components/margin.model';
import { BackgroundMedia } from '../models/page-components/background-media.model';
import { Border } from '../models/page-components/border.model';
import { ImagePipe } from '../pipes/image.pipe';
import { Typography } from '../models/layout/typography.model';

@Injectable({
  providedIn: 'root',
})
export class StyleService {
  settingsService = inject(SettingsService);
  imagePipe = inject(ImagePipe);
  document = inject(DOCUMENT);
  platformId = inject(PLATFORM_ID);

  imagePath = environment.imagePath;

  getPaddings(padding: Padding | null, settingsPadding: Padding | null) {
    if (!padding && !settingsPadding) return [];

    const isMobile = this.settingsService.getMobileStatus();
    const isTablet = this.settingsService.getTabletStatus();

    let output: string[] = [];

    if (isTablet) {
      output.push(
        `padding-top: ${
          padding?.Tablet?.Top && padding.Tablet.Top != ''
            ? padding.Tablet.Top
            : (settingsPadding?.Tablet?.Top ?? '0px')
        }`,
      );

      output.push(
        `padding-right: ${
          padding?.Tablet?.Right && padding.Tablet.Right != ''
            ? padding.Tablet.Right
            : (settingsPadding?.Tablet?.Right ?? '0px')
        }`,
      );

      output.push(
        `padding-bottom: ${
          padding?.Tablet?.Bottom && padding.Tablet.Bottom != ''
            ? padding.Tablet.Bottom
            : (settingsPadding?.Tablet?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `padding-left: ${
          padding?.Tablet?.Left && padding.Tablet.Left != ''
            ? padding.Tablet.Left
            : (settingsPadding?.Tablet?.Left ?? '0px')
        }`,
      );
    } else if (isMobile) {
      output.push(
        `padding-top: ${
          padding?.Mobile?.Top && padding.Mobile.Top != ''
            ? padding.Mobile.Top
            : (settingsPadding?.Mobile?.Top ?? '0px')
        }`,
      );

      output.push(
        `padding-right: ${
          padding?.Mobile?.Right && padding.Mobile.Right != ''
            ? padding.Mobile.Right
            : (settingsPadding?.Mobile?.Right ?? '0px')
        }`,
      );

      output.push(
        `padding-bottom: ${
          padding?.Mobile?.Bottom && padding.Mobile.Bottom != ''
            ? padding.Mobile.Bottom
            : (settingsPadding?.Mobile?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `padding-left: ${
          padding?.Mobile?.Left && padding.Mobile.Left != ''
            ? padding.Mobile.Left
            : (settingsPadding?.Mobile?.Left ?? '0px')
        }`,
      );
    } else {
      output.push(
        `padding-top: ${
          padding?.Desktop?.Top && padding.Desktop.Top != ''
            ? padding.Desktop.Top
            : (settingsPadding?.Desktop?.Top ?? '0px')
        }`,
      );

      output.push(
        `padding-right: ${
          padding?.Desktop?.Right && padding.Desktop.Right != ''
            ? padding.Desktop.Right
            : (settingsPadding?.Desktop?.Right ?? '0px')
        }`,
      );

      output.push(
        `padding-bottom: ${
          padding?.Desktop?.Bottom && padding.Desktop.Bottom != ''
            ? padding.Desktop.Bottom
            : (settingsPadding?.Desktop?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `padding-left: ${
          padding?.Desktop?.Left && padding.Desktop.Left != ''
            ? padding.Desktop.Left
            : (settingsPadding?.Desktop?.Left ?? '0px')
        }`,
      );
    }

    return output;
  }

  getMargins(margin: Margin | null, settingsMargin: Margin | null) {
    if (!margin && !settingsMargin) return [];

    const isMobile = this.settingsService.getMobileStatus();
    const isTablet = this.settingsService.getTabletStatus();

    let output: string[] = [];

    if (isTablet) {
      output.push(
        `margin-top: ${
          margin?.Tablet?.Top && margin.Tablet.Top != ''
            ? margin.Tablet.Top
            : (settingsMargin?.Tablet?.Top ?? '0px')
        }`,
      );

      output.push(
        `margin-right: ${
          margin?.Tablet?.Right && margin.Tablet.Right != ''
            ? margin.Tablet.Right
            : (settingsMargin?.Tablet?.Right ?? '0px')
        }`,
      );

      output.push(
        `margin-bottom: ${
          margin?.Tablet?.Bottom && margin.Tablet.Bottom != ''
            ? margin.Tablet.Bottom
            : (settingsMargin?.Tablet?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `margin-left: ${
          margin?.Tablet?.Left && margin.Tablet.Left != ''
            ? margin.Tablet.Left
            : (settingsMargin?.Tablet?.Left ?? '0px')
        }`,
      );
    } else if (isMobile) {
      output.push(
        `margin-top: ${
          margin?.Mobile?.Top && margin.Mobile.Top != ''
            ? margin.Mobile.Top
            : (settingsMargin?.Mobile?.Top ?? '0px')
        }`,
      );

      output.push(
        `margin-right: ${
          margin?.Mobile?.Right && margin.Mobile.Right != ''
            ? margin.Mobile.Right
            : (settingsMargin?.Mobile?.Right ?? '0px')
        }`,
      );

      output.push(
        `margin-bottom: ${
          margin?.Mobile?.Bottom && margin.Mobile.Bottom != ''
            ? margin.Mobile.Bottom
            : (settingsMargin?.Mobile?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `margin-left: ${
          margin?.Mobile?.Left && margin.Mobile.Left != ''
            ? margin.Mobile.Left
            : (settingsMargin?.Mobile?.Left ?? '0px')
        }`,
      );
    } else {
      output.push(
        `margin-top: ${
          margin?.Desktop?.Top && margin.Desktop.Top != ''
            ? margin.Desktop.Top
            : (settingsMargin?.Desktop?.Top ?? '0px')
        }`,
      );

      output.push(
        `margin-right: ${
          margin?.Desktop?.Right && margin.Desktop.Right != ''
            ? margin.Desktop.Right
            : (settingsMargin?.Desktop?.Right ?? '0px')
        }`,
      );

      output.push(
        `margin-bottom: ${
          margin?.Desktop?.Bottom && margin.Desktop.Bottom != ''
            ? margin.Desktop.Bottom
            : (settingsMargin?.Desktop?.Bottom ?? '0px')
        }`,
      );

      output.push(
        `margin-left: ${
          margin?.Desktop?.Left && margin.Desktop.Left != ''
            ? margin.Desktop.Left
            : (settingsMargin?.Desktop?.Left ?? '0px')
        }`,
      );
    }

    return output;
  }

  isNullOrEmty(value: string | null) {
    return value === null || value === '';
  }

  getBackgroundMedia(backgroundMedia: BackgroundMedia) {
    if (!backgroundMedia) return [];

    let output: string[] = [];

    output.push(
      `background-color: ${backgroundMedia.BackgroundColor ?? 'initial'}`,
    );

    if (backgroundMedia.Image) {
      if (backgroundMedia.Image.Url) {
        // Get viewport dimensions - use defaults during SSR
        let viewportWidth = 1920;
        let viewportHeight = 1080;

        // if (isPlatformBrowser(this.platformId)) {
        //   viewportWidth = this.document.body.clientWidth;
        //   viewportHeight = this.document.body.clientHeight;
        // } else {
        // Use device-appropriate defaults during SSR
        const isMobile = this.settingsService.getMobileStatus();
        const isTablet = this.settingsService.getTabletStatus();

        if (isMobile) {
          viewportWidth = 375;
          viewportHeight = 667;
        } else if (isTablet) {
          viewportWidth = 768;
          viewportHeight = 1024;
        } else {
          viewportWidth = 1920;
          viewportHeight = 1080;
        }
        // }

        output.push(
          `background-image: url('${this.imagePipe.transform(
            backgroundMedia.Image.Url,
            viewportWidth,
            backgroundMedia.Image,
            'fill',
            viewportHeight,
            true,
            backgroundMedia.Quality,
          )}')`,
        );

        output.push(
          'background-repeat: ' +
            (backgroundMedia.BackgroundImageRepeat
              ? backgroundMedia.BackgroundImageRepeat
              : 'no-repeat'),
        );

        output.push(
          'background-size: ' +
            (backgroundMedia.BackgroundImageSize
              ? backgroundMedia.BackgroundImageSize
              : 'cover'),
        );
        output.push(
          'background-position: ' +
            (backgroundMedia.BackgroundImagePosition
              ? backgroundMedia.BackgroundImagePosition
              : 'center center'),
        );
      }
    }
    return output;
  }

  getBorder(border: Border | null) {
    if (!border) return '';

    let output: string[] = [];

    if (border.Color)
      output.push(
        `border: ${border.Width ?? '1px'} solid ${border.Color ?? '#000'}`,
      );
    if (border.Width) output.push(`border-radius: ${border.Radius ?? '0px'}`);

    if (border.Radius) output.push(`border-radius: ${border.Radius}`);

    return output;
  }

  getTypographyStyles(typography: Typography | null, defaults?: Typography) {
    if (!typography || Object.keys(typography).length === 0) return [];

    let output: string[] = [];
    if (typography.FontFamily || defaults?.FontFamily)
      output.push(
        `font-family: ${typography.FontFamily || defaults?.FontFamily || 'inherit'} !important`,
      );

    if (typography.FontSize || defaults?.FontSize)
      output.push(
        `font-size: ${typography.FontSize || defaults?.FontSize || 'inherit'} !important`,
      );

    if (typography.FontWeight || defaults?.FontWeight)
      output.push(
        `font-weight: ${typography.FontWeight || defaults?.FontWeight || 'normal'} !important`,
      );

    if (typography.LetterSpacing || defaults?.LetterSpacing)
      output.push(
        `letter-spacing: ${typography.LetterSpacing || defaults?.LetterSpacing || 'normal'} !important`,
      );

    if (typography.Color || defaults?.Color)
      output.push(
        `color: ${typography.Color || defaults?.Color || 'inherit'} !important`,
      );

    if (typography.LineHeight || defaults?.LineHeight)
      output.push(
        `line-height: ${typography.LineHeight || defaults?.LineHeight || 'normal'} !important`,
      );

    if (typography.TextTransform || defaults?.TextTransform)
      output.push(
        `text-transform: ${typography.TextTransform || defaults?.TextTransform || 'none'} !important`,
      );

    if (typography.TextDecoration || defaults?.TextDecoration)
      output.push(
        `text-decoration: ${typography.TextDecoration || defaults?.TextDecoration || 'none'} !important`,
      );
    return output;
  }
}
